<template>
    <div>
        <gift-progress-submenu
            :steps-number="stepsNumber"
            :step="step"
            :title="title"
            :previous-step="previousStep"
            :next-step="nextStep"/>
        <transition>
            <section>
                <router-view></router-view>
            </section>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GiftingSteps from '@/config/GiftingSteps';
import GiftProgressSubmenu from '@/components/partials/account/gifting/GiftProgressSubmenu';
import GiftingService from '@/services/gifting/GiftingService';

export default {
    name: 'Gifting',
    components: {
        GiftProgressSubmenu,
    },
    data() {
        return {
            steps: GiftingSteps.steps,
            giftingService: new GiftingService(),
        };
    },
    mounted() {
        this.user.is_payment_user ? this.$store.dispatch('cookies/mountPrimer') : this.$store.dispatch('cookies/mountChargebee');
        this.$store.commit('gifting/updateCurrentStep', this.step - 1);
        this.$store.commit('gifting/updateTotalSteps', this.stepsNumber);
        this.$store.commit('gifting/updateGiftingAddress', this.giftingAddress);
        this.$store.commit('gifting/updateIncompleteGiftingData', null);
        if (this.step > 1) {
            setTimeout(() => {
                this.giftingService.sendIncompleteGiftingData(this.incompleteGiftingData, this.incompleteGiftingId, this.userId)
                    .then(resp => {
                        if (resp !== null) this.$store.commit('gifting/setincompleteGiftingId', resp);
                    });
            }, 10);
        }
    },
    computed: {
        ...mapGetters({
            user: 'account/getUser',
            giftType: 'gifting/getGiftType',
            giftingAddress: 'address/getSelectedGiftingAddress',
            incompleteGiftingData: 'gifting/getIncompleteGifting',
            incompleteGiftingId: 'gifting/getIncompleteGiftingId',
            userId: 'account/getUserId',
        }),
        giftTypeSteps() {
            return this.steps.filter((step) => {
                return step.enabled === true && (this.giftType === null || step.type.includes(this.giftType));
            });
        },
        nextStep() {
            return this.step < this.stepsNumber ? this.giftTypeSteps[this.stepIndex + 1].routeName : null;
        },
        previousStep() {
            return this.step > 1 ? this.giftTypeSteps[this.stepIndex - 1].routeName : null;
        },
        step() {
            return 1 + this.stepIndex;
        },
        stepIndex() {
            return this.giftTypeSteps
                .map((step) => step.routeName)
                .indexOf(this.$route.name);
        },
        stepsNumber() {
            return this.giftTypeSteps.length - 1;
        },
        title() {
            return this.giftTypeSteps[this.stepIndex].title;
        },
    },
};
</script>
